// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".psa-tooltip{margin:3px 0;padding:0 8px 0 22px}", ""]);
// Exports
module.exports = exports;
